"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CompetitorProductFilter_1 = require("../../product/model/CompetitorProductFilter");

var CompetitorProductFilterConverter_1 = require("./CompetitorProductFilterConverter");
/**
 * Implementation of {@link CompetitorProductFilterConverter}.
 *
 * @author Radek Beran
 */


var CompetitorProductFilterConverterImpl =
/*#__PURE__*/
function (_CompetitorProductFil) {
  _inherits(CompetitorProductFilterConverterImpl, _CompetitorProductFil);

  function CompetitorProductFilterConverterImpl() {
    _classCallCheck(this, CompetitorProductFilterConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorProductFilterConverterImpl).call(this));
  }
  /**
   * @inheritDoc
   */


  _createClass(CompetitorProductFilterConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new CompetitorProductFilter_1.CompetitorProductFilter(source.textForSearch, source.ignored, source.competitorIds ? conversions.asObjectList(source, 'competitorIds', function (id) {
        return id;
      }) : undefined);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        textForSearch: source.textForSearch,
        ignored: source.ignored,
        competitorIds: conversions.asObjectArray(source, 'competitorIds', function (id) {
          return id;
        })
      });
      return result;
    }
  }]);

  return CompetitorProductFilterConverterImpl;
}(CompetitorProductFilterConverter_1.CompetitorProductFilterConverter);

exports.CompetitorProductFilterConverterImpl = CompetitorProductFilterConverterImpl;